var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from "@mui/material";
import clsx from "clsx";
import { useMemo } from "react";
import { useStyles } from "./ui_card.css";
export const UiCard = (_a) => {
    var { children, className, color = "default", fullHeight, fullWidth } = _a, props = __rest(_a, ["children", "className", "color", "fullHeight", "fullWidth"]);
    const classes = useStyles();
    return useMemo(() => (_jsx(Card, Object.assign({ className: clsx(className, classes.ui_card, {
            [classes.ui_card__full_height]: fullHeight,
            [classes.ui_card__full_width]: fullWidth,
            [classes.ui_card__variant_default]: color === "default",
            [classes.ui_card__variant_error]: color === "error",
            [classes.ui_card__variant_info]: color === "info",
            [classes.ui_card__variant_primary]: color === "primary",
            [classes.ui_card__variant_primary_light]: color === "primary_light",
            [classes.ui_card__variant_warning]: color === "warning",
        }) }, props, { children: children }))), [children, classes, className, color, fullHeight, fullWidth, props]);
};
//# sourceMappingURL=ui_card.js.map